import { LOW_OPACITY } from '../bars/constants';

interface GetOpacityProps {
  currentItemKey: string;
  hoveredItemKey: string | null;
  isIncorrect?: boolean;
}

export const getOpacity = ({
  currentItemKey,
  hoveredItemKey,
  isIncorrect = false,
}: GetOpacityProps) => {
  if (hoveredItemKey === currentItemKey) {
    return 1;
  }
  if (hoveredItemKey !== null && hoveredItemKey !== currentItemKey) {
    return LOW_OPACITY;
  }
  if (isIncorrect) {
    return LOW_OPACITY;
  }
  return 1;
};
